import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';

@Entity('line_target_eff')
export class LineTargetEffEntity {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: string;

    @Column('varchar',{
        nullable:false,
        length: 10,
        name:'unit_id'
    })
    unitId: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'line_id'
    })
    lineId: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'style_id'
    })
    styleId: string;

    @Column('date', {
        nullable: false,
        name: 'plan_date'
    })
    planDate: string;

    @Column('decimal', {
        nullable: false,
        name: 'efficiency',
        scale: 5,
        precision: 2
    })
    efficiency: number;

    @Column('boolean', {
        nullable:false,
        default: true,
        name:'is_active'
    })
    isActive:boolean;

    @CreateDateColumn({name: 'created_at'})
    createdAt: Date;

}
